var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6807 10.82H17.4007L16.094 10.2497L14.7873 9.67938H16.3607C16.935 9.67938 17.4007 9.21375 17.4007 8.63938V6.9C17.4007 3.3 14.4673 0.366669 10.8673 0.366669C7.26733 0.366669 4.334 3.3 4.334 6.9V8.62002C4.334 9.1944 4.79962 9.66002 5.374 9.66002H6.94733L4.334 10.82H1.08066C0.733997 10.82 0.440664 11.1133 0.440664 11.4867V16.0467C0.413997 21.8333 5.10733 26.5 10.8673 26.5C16.654 26.5 21.3207 21.8333 21.3207 16.0467V11.4867C21.3207 11.1133 21.0273 10.82 20.6807 10.82ZM10.8673 20.1267C9.774 20.1267 8.32066 19.22 8.32066 17.3533C8.32066 16.26 8.99101 14.9267 10.9207 14.9267C12.7567 14.9267 13.5207 16.2867 13.5207 17.3533C13.5207 19.22 11.9607 20.1267 10.8673 20.1267ZM6.94733 10.82H4.334L6.94733 9.66002V6.9C6.94733 4.74 8.70733 2.98 10.8673 2.98C13.0273 2.98 14.7873 4.74 14.7873 6.9V9.67938L16.094 10.2497L17.4007 10.82H14.7873H6.94733Z",
    fill: "#807CE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.84,
    height: 26,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.c32f31b8753731a7951901fdfcf6271d.svg";
export { ForwardRef as ReactComponent };